import { ShiftsLocationFragment } from 'generated/resources/graphql'
import uniq from 'lodash/uniq'
import { computed, makeObservable } from 'mobx'
import type moment from 'moment'

import Holiday from 'modules/shift_management/store/internal/models/Holiday'

class Holidays {
  holidays: Holiday[]

  constructor(holidays: Holiday[]) {
    this.holidays = holidays

    makeObservable(this, {
      holidaysLength: computed,
      holidaysInformation: computed,
    })
  }

  static buildFromGraphQL(location: ShiftsLocationFragment | undefined | null): Holidays {
    const holidays = location?.companyHolidays || []
    const holidayObjects = holidays.map((holiday) => Holiday.buildFromGraphQL(holiday, location))

    return new Holidays(holidayObjects)
  }

  get holidaysLength(): number {
    return this.holidays.length
  }

  get holidaysInformation(): (string | undefined)[] {
    return uniq(
      this.holidays.map((holiday) => {
        return holiday.location
          ? `${holiday.summary} - ${holiday.location.name}`
          : `${holiday.summary}`
      })
    )
  }

  filterByDate(date: moment.Moment): Holiday[] {
    return this.holidays.filter((holiday) => date.isSame(holiday.date, 'day'))
  }

  filterByDateAndLocation(date: moment.Moment, id: string): Holiday[] {
    return this.holidays.filter((holiday) => holiday.isDate(date) && holiday.location?.id === id)
  }
}

export default Holidays
